<template lang="html">

  <section class="panel-info-evenement">
    <div class="siteinfo">
      <div class="row ">
        <div class="col-md-8 ">
            <div class="sitePicture">
                <!--<img src="../assets/img/fim_poster.jpg" alt="" class="picturebg">-->
                <img :src="evenement.image" alt="" class="picturebg">
                <div class="overlay text-center">
                    <!--<img src="../assets/img/fim_poster.jpg" alt="" srcset="" > -->
                    <img :src="evenement.image" alt="" srcset="" > 
                </div>
            </div>
        </div>
        <div class="col-md-4 price">
            <p class="date">{{evenement.debut}}</p>
            <h5 class="title">{{evenement.titre}}</h5>
            <!--<a name="" id="designation" class="btn btn-outline-primary" href="#" role="button">ACTION</a><br/><br/>
            <div class=" rmajestic ">
                <p class="text-truncate"><a href="#"><img src="../assets/img/majestic_logo.jpg" class="rounded-circle float-left " /> Majestic Cinema Group</a></p>
            </div><br/>
            <p class="prix">2000 FCFA</p>-->
            <br/>
            <a id="buy-Btn" class="btn btn-yellow" v-smooth-scroll href="#sectioninscription">ACHETER UN TICKET</a> <!--id="buy-Btn" #section-inscription-->
            <!--&nbsp;
            <button id="share-Btn" class="btn btn-outline-primary  btn-circle boutP">
                <i class="fa fa-share-alt" aria-hidden="true"></i>
            </button>-->
        </div>
      </div>
      <hr/>
      <div class="row">
          <div class="col-md-8">
              <h4>Description</h4>
              <div class="text-justify">
                  <p>
                      {{evenement.description}}
                  </p>
              </div>
          </div>
      </div>
      <hr/>
      <div class="row" id="sectioninscription">
          <div class="col-md-12">
            <h4>Paiement</h4>
            <iframe width="100%" :src="'https://billeterie.skanticket.com/paiement?evenementId=' + evenementId"/>
          </div>
      </div>
  </div>
  </section>

</template>

<script lang="js">
  import axios from 'axios'

  export default  {
    name: 'panel-info-evenement',
    props: [
        'evenementId'
    ],
    created() {
        axios
        .get('https://skanticket.com/evenement.php?id=' + this.evenementId)
        .then(response => {
          this.evenement = response.data.donnee;
        })
    },
    mounted() {
        /*axios
        .get('http://skanticket.com/evenement.php?id=' + this.evenementId)
        .then(response => {
          this.evenement = response.data.donnee;
        })*/
    },
    data() {
      return {
          evenement :{} 
      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style>
 iframe{
   min-height: 600px;
   border: 0;
 }
</style>
